import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',

      '& $field + $field': {
        marginTop: '18px',
      },
      '& $field + $content': {
        marginTop: '18px',
      },
    },
    fieldLabel: {
      color: '#8E969D',
      fontWeight: theme.typography.fontWeightRegular,
    },
    field: {},
    fieldName: {},
    fieldType: {},
    content: {},
    errorPanel: {
      margin: '18px 0',
    },
  }),
  { name: 'BriefForm' }
);
